import { capitalize } from 'lodash';

const internalToDisplayName: Record<string, string> = {
  SAStarter: 'Starter',
  SAPro: 'Pro',
  SAScale: 'Scale',
};

export const getFormattedPlanName = (plan: string) => {
  if (!plan) return '';
  if (plan === 'Free Plan') return 'Free Plan';
  const [planName, frequency] = plan.split('-');
  const interval = frequency?.toLowerCase() === 'yearly' ? 'annually' : 'monthly';
  const displayName = internalToDisplayName[planName] ?? capitalize(planName.toLowerCase().replace('plan', ''));

  if (plan === 'SAPro-Trial') {
    return 'Pro Trial';
  }

  return `${displayName} (${interval})`;
};

export const planNameToSlug = (plan: string) => {
  return plan.replace(/^SA/, 'sa').toLowerCase();
};

export const convertToK = (num: number) => {
  if (num >= 1000) {
    return `${Math.round(num / 1000)}K`;
  }
  return num;
};
